import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from 'react'

interface FastCasualContextInterface {
  verified: boolean
  setVerified: (value: boolean) => void
}

const FastCasualContext = createContext({} as FastCasualContextInterface)

export const useFastCasualContext = () => useContext(FastCasualContext)

interface FastCasualContextProviderProps {
  children: ReactNode
}

export default function FastCasualContextProvider(
  props: FastCasualContextProviderProps
) {
  const { children } = props

  const [verified, setVerified] = useState(false)

  useEffect(() => {
    // Check if code is running in browser environment

    if (
      typeof window !== 'undefined' &&
      localStorage.getItem('fc100access') === 'true'
    ) {
      setVerified(true)
    }
  }, []) // Empty dependency array as we only need to run this once

  return (
    <FastCasualContext.Provider value={{ verified, setVerified }}>
      {children}
    </FastCasualContext.Provider>
  )
}
